import { Comparison } from './../../comparison';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-select-list',
  templateUrl: './select-list.component.html',
  styleUrls: ['./select-list.component.css']
})
export class SelectListComponent implements OnInit {

  @Input() items: any;
  @Input() selectedItem: any;
  @Output() selectedItemChange = new EventEmitter<any>();

  @Input()public adapter: IListItemAdapter = new DefaultListItemAdapter();

  filter: string;

  constructor() { }

  ngOnInit() {
    // console.log("ngOnInit: " + JSON.stringify(this.items));
  }

  onFilterKey(evt: KeyboardEvent) {
    if (evt.keyCode === 27) { // escape key
      this.filter = '';
    }
  }

  get matchingItems() {
    if (!this.filter || this.filter.length < 1) {
      return this.items;
    }

    let lowerFilter = this.filter.toLowerCase();
    return this.items.filter(x => this.adapter.getText(x).toLowerCase().indexOf(lowerFilter) >= 0);
  }

  onSelectionChange(entry) {
    // console.log("onSelectionChange: " + JSON.stringify(entry));
    this.selectedItem = entry;
    this.selectedItemChange.emit(entry);
  }
}

export class Entity {
  text: string;
  item: any;

  constructor(text: string, item: any) {
    this.text = text;
    this.item = item;
  }
}

export interface IListItemAdapter {
  getId(item);
  getText(item);
  areSame(a, b);
  indexOf(items, item);
}

export class StringAdapter {
  getId(item) {
    return item;
  }
  getText(item) {
    return item;
  }
  areSame(a, b) {
    return a === b;
  }
  indexOf(items, item) {
    return items.indexOf(item);
  }
}

export class DefaultListItemAdapter {
  getId(item) {
    if (!item) {
      return null;
    }

    return item['id'] + '|' + item['name'];
  }

  getText(item) {
    if (!item) {
      return null;
    }

    return item['name'];
  }

  areSame(a, b) {
    return this.getId(a) === this.getId(b);
  }

  indexOf(items, item) {
    for (let i = 0; i < items.length; i++) {
      if (this.areSame(items[i], item)) {
        return i;
      }
    }

    return -1;
  }
}
